/**
 * Scene manifests registry — one SceneManifest per game, looked up by game id.
 *
 * Mirrors the Store manifest philosophy (src/assets/manifest.ts): a game's set of
 * parallax scenes is data, resolved once and reused. New games register here; the
 * stage view asks `scenesForGame(gameId)` and hands the result to SceneStack.
 */

import type { SceneManifest } from './types.js';
import { bloodmoonScenes } from './bloodmoon.js';
import { whisperScenes } from './whisper.js';

export type { SceneManifest, SceneDef, SceneLayer, SceneParticles, SceneSlot, PresetName } from './types.js';
export { bloodmoonScenes } from './bloodmoon.js';
export { whisperScenes } from './whisper.js';

const REGISTRY: Record<string, SceneManifest> = {
  bloodmoon: bloodmoonScenes,
  whisper: whisperScenes,
};

/** The scene manifest for a game, or undefined if the game has no set defined. */
export function scenesForGame(gameId: string): SceneManifest | undefined {
  return REGISTRY[gameId];
}
